import {
  SectionContainer,
  ContentContainer,
  LogoContainer,
  Title,
  Description
} from './styles';
import logoImage from '../../../assets/images/logo.png';

const DifferentialSection = () => {
  return (
    <SectionContainer>
      <ContentContainer>
        <LogoContainer>
          <img src={logoImage} alt="Floqss" />
        </LogoContainer>

        <Title>Nuestro Diferencial</Title>

        <Description>
          Nuestro modelo es único: pensado para quienes desconfían de pagar antes o no tienen acceso a tarjetas o bancos.
          Creada para quienes desconfían del sistema y siempre fueron ignorados por el mercado digital.
          Llevamos conocimiento a millones de personas que siempre quedaron por fuera.
          Y para los creadores, abrimos un mercado inédito: más de 23,35 millones de Colombianos aún no alcanzados por nadie.
        </Description>
      </ContentContainer>
    </SectionContainer>
  );
};

export default DifferentialSection;